import React, { useEffect, useRef, useState } from "react";
import VanillaTilt from "vanilla-tilt";
import emailjs from "@emailjs/browser";
import swal from "sweetalert";

const Contacts = () => {
  useEffect(() => {
    VanillaTilt.init(document.querySelectorAll(".skewani"), {
      max: 5,
      speed: 400,
    });
  }, []);

  const form = useRef();
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    if (loading) {
      return;
    }
    setLoading(true);

    emailjs
      .sendForm("service_zrk6qa3", "template_9ac3e4p", form.current, {
        publicKey: "knRphAyUJ8p25q4dT",
      })
      .then(
        () => {
          setLoading(false);
          form.current.reset();
          swal({
            title: "Success!",
            text: "Your message has been sent.",
            icon: "success",
            button: "OK",
          });
        },
        (error) => {
          setLoading(false);
          swal({
            title: "Error!",
            text: "Failed to send your message.",
            icon: "error",
            button: "Retry",
          });
        }
      );
  };

  return (
    <section className="contact_section add_zindex">
      <div id="Contact" className="first1"></div>
      <h2
        className="mx-auto mb-4 underline contact__title"
        data-aos="fade-down"
      >
        Contact
      </h2>

      <div className="mb-3 row">
        <div className="contact__box" data-aos="fade-down" data-aos-delay="200">
          <a href="mailto:kchitraarasu@gmail.com">
            <div className="p-3 mx-auto mt-3 text-center shadow card card2 skewani">
              <div className="card-body">
                <div className="pulse">
                  <i className="fa fa-envelope"></i>
                </div>
                <h4 className="mb-2 card-subtitle">Email</h4>
                <p className="card-text">kchitraarasu@gmail.com</p>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div className="contact__container">
        <form ref={form} onSubmit={sendEmail} className="contact__form">
          <input
            name="name"
            id="name"
            type="text"
            placeholder="Name"
            className="contact__input"
            data-aos="fade-down"
            data-aos-delay="200"
            required
          />
          <input
            name="email"
            id="email"
            type="email"
            placeholder="Email"
            className="contact__input"
            data-aos="fade-down"
            data-aos-delay="200"
            required
          />
          <textarea
            name="message"
            cols="0"
            rows="10"
            className="contact__input"
            data-aos="fade-down"
            data-aos-delay="200"
            required
          ></textarea>
          <button
            type="submit"
            className="contact__button"
            data-aos="fade-down"
            data-aos-delay="200"
            disabled={loading}
          >
            {loading ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              <>
                <i className="fa fa-envelope-o"></i> Submit
              </>
            )}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contacts;
